export default __webpack_public_path__ + "static/media/francheville01min.0688efc1.jpg";